import React, { useState, useEffect } from "react";
import { axiosReq, axiosReq2 } from "../../commons/axiosReq";
import User from "../../assets/icon/NewsIcons/MainAdmin/NewsPerson"
import Search from "../../assets/icon/NewsIcons/MainAdmin/NewsSearch"
import Report from "../../assets/icon/NewsIcons/MainAdmin/NewsReport"
import { MainAdminTables, AddModalWriters, DeleteModalWriters } from "../../components"
import AddModalAdmin from "../../components/MainAdmin/Modals/AddModalAdmin";
import SettingModal from "../../components/MainAdmin/Modals/SettingModal";
import { Link, useNavigate } from "react-router-dom";
import Cookies from 'universal-cookie';
import axios from "axios";
import AddModalWordCloud from "../../components/MainAdmin/Modals/AddModalWordCloud";
const MainAdminWordCloud = () => {


    const [showAddModal, setShowAddModal] = useState(false);
    const [showAddModalFile, setShowAddModalFile] = useState(false);

    const [reCheck, setRecheck] = useState(false);
    const [writersList, setWritersList] = useState([]);
    const [data, setData] = useState();
    const [search, setSearch] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [count, setCount] = useState();
    const [page, setPage] = useState(1);
    const [row, setRow] = useState(10);
    const itemsPerPage = 10;
    let navigate = useNavigate();

    // const GetData = async () => {
    //     const cookies = new Cookies();

    //     var id = cookies.get('userConnectId');
    //     const writersData = await axiosReq2("admin/rag_access/rag_systems?user_id=" + id, "get");

    //     setData(writersData)
    // }
    const auth = async () => {
        const cookies = new Cookies();
        var token = cookies.get('token');
        console.log(token)
        console.log(cookies.get('role'))
        if (!token) {
            navigate("/");
        }
        else {
            //     if( cookies.get('role')=="Admin")
            //    {

            // GetData()
            //    }


            //     else {
            //         navigate("/admin");

            //     }
        }
    }
    useEffect(() => {

        auth();
    }, [reCheck, search, page, row,]);

  
    return (
        <div>
            <div className="p-[20px] flex justify-between items-center border-b-2 border-borderGray">
                <div className="flex justify-start items-center">
                    <div><User color={'black'} /></div>
                    <p className="font-IRANYekanExtra text-[15px] mr-[15px]">ساخت ابر کلمات</p>
                </div>
                <div className="flex justify-start items-center">
                    {/* <div className="w-[238px] h-[40px] rounded-[10px] shadow-search-shadow p-[10px] flex justify-between items-center">
                        <input onChange={(e) => setSearch(e.target.value)} className="font-IRANYekanNormal focus:outline-none placeholder-lightGray" type="text" placeholder="جستجو کنید ..." />
                        <button><Search /></button>
                    </div> */}
                
                    {/* <button onClick={() => setShowAddModal(true)} className="w-[154px] h-[40px] bg-Orange2 shadow-norm-shadow rounded-[10px] mr-[10px] flex justify-center items-center ">
                        <p className="font-IRANYekanLight text-[28px] text-white">+</p>
                        <p className="font-IRANYekanBold text-[14px] text-white mr-[7px]">افزودن </p>
                    </button> */}
                </div>
            </div>
            <div className="pt-[20px] px-[20px] pb-[280px]">
                <div className="flex flex-wrap items-center justify-evenly">
                    {/* <Link
                        // to={"/chat"}
                        onClick={() => StartChatAssistant()}
                        className="w-[30%] h-[100px]  flex justify-center items-center rounded-3xl  shadow-3xl">
                        <p className="font-IRANYekanBold text-[18px] text-mainColor2 ">(mofid)چت صوتی و متنی</p>
                    </Link>
                    <Link onClick={() => StartChat()} className="w-[30%] h-[100px] flex justify-center items-center rounded-3xl shadow-3xl">
                        <p className="font-IRANYekanBold text-[18px] text-mainColor2 ">دارویاب</p>
                    </Link>
                    <Link to={"/chatDeepSeek"} className="w-[30%] h-[100px] flex justify-center items-center rounded-3xl shadow-3xl">
                        <p className="font-IRANYekanBold text-[18px] text-mainColor2 ">دیپ سیک</p>
                    </Link>*/}
                           <button onClick={() => setShowAddModal(true)} className="w-[30%] h-[100px] mt-4 flex justify-center items-center rounded-3xl shadow-3xl">
                                    <p className="font-IRANYekanBold text-[18px] text-mainColor2 ">متن</p>
                                </button> 
                                  <button onClick={() => setShowAddModalFile(true)} className="w-[30%] h-[100px] mt-4 flex justify-center items-center rounded-3xl shadow-3xl">
                                    <p className="font-IRANYekanBold text-[18px] text-mainColor2 ">فایل</p>
                                </button> 
                 
                </div>

            {showAddModal ? <AddModalWordCloud title={' کلمه '} buttonName={'ثبت'} setShowModal={setShowAddModal} reCheck={reCheck} setRecheck={setRecheck} type={"name"}/> : null}
            {showAddModalFile ? <AddModalWordCloud title={' کلمه '} buttonName={'ثبت'} setShowModal={setShowAddModalFile} reCheck={reCheck} setRecheck={setRecheck}  type={"file"}/> : null}

            </div>



        </div>
    )
}

export default MainAdminWordCloud;